export enum enumPaymentEntity {
  ISF = 'ISF',
  ES = 'ES',
  SH = 'SH',
  BR = 'BR',
  MI = 'MI',
  COMPANY = 'company',
  DS = 'DS',
}
